import { createMuiTheme, Theme } from '@material-ui/core/styles';
import { COLORS } from 'constants/design';

const CorporealTheme: Theme = createMuiTheme({
  typography: {
    fontFamily: 'Roboto',
  },
  palette: {
    type: 'light',
    primary: {
      main: COLORS.BLUE,
    },
    secondary: {
      main: COLORS.WHITE,
      contrastText: COLORS.TEXT_BLACK,
    },
  },
  overrides: {
    MuiStepLabel: {
      label: {
        color: '#0074ba !important',
        fontWeight: 'bold',
        marginTop: '-55px !important',
      },
    },
    MuiInputBase: {
      input: {
        color: '#2b2727 !important',
        fontSize: '14px',
        opacity: 1,
      },
    },
    MuiOutlinedInput: {
      root: {
        '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
          borderColor: 'white',
          '&.MuiSvgIcon-root': {
            background: 'red',
          },
        },
        '&.Mui-disabled svg': {
          display: 'none',
        },
      },
    },
    MuiButton: {
      contained: {
        float: 'right',
        color: '#333E48',
        backgroundColor: 'white',
        boxShadow: 'none',
        border: '1px solid #6b787f',
        borderRadius: '4px',
        '&:hover': {
          backgroundColor: 'white',
          boxShadow: 'none',
        },
      },
    },
    MuiInputLabel: {
      shrink: {
        transform: 'translate(0px, -6px) scale(0.75) !important',
        color: '#00000061',
      },
    },
    MuiExpansionPanel: {
      root: {
        boxShadow: 'none',
        '&.Mui-expanded:first-child': {
          marginTop: '20px',
        },
      },
    },
    MuiExpansionPanelDetails: {
      root: {
        padding: '8px 5px 24px',
      },
    },
    MuiExpansionPanelSummary: {
      root: {
        padding: '8px 5px',
        height: '36px !important',
        background: '#f5f5f5',
        margin: '0 16px',
        color: '#0072c6',
        fontSize: '14px',
        fontWeight: 'bold',
        '&.Mui-expanded': {
          height: '36px !important',
          minHeight: '36px !important',
          background: '#f5f5f5',
          margin: '0 16px',
          color: '#0072c6',
          fontSize: '14px',
          fontWeight: 'bold',
        },
      },
    },
    MuiTable: {
      root: {
        background: '#fff',
      },
    },
  },
});

export default CorporealTheme;
